module.exports = __webpack_public_path__ + "img/icon71.1bb5ac72.png";